<template>
  <div class="time-filter">
    <active-button
      v-for="h in suite"
      :key="h"
      :active="h === hours"
      @click="$emit('change', h)"
    >
      {{ h === 0 ? $t('filters.time.all') : h + $t('filters.time.h') }}
    </active-button>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'

export default {
  components: { ActiveButton },
  props: {
    hours: Number,
    suite: Array
  }
}
</script>

<style scoped>
.time-filter { display: flex; margin-left: 5px; margin-right: 10px; margin-top: 5px; background: linear-gradient(to top right,#713592,#342d6e); border-radius: 10px; }
.active-button { font-size: 11px; height: 30px; line-height: 30px; /* padding: 0 6px; */ width: 38px; font-weight: bold; color: white; /* background: rgba(0,0,0,0.2); */ text-align: center; }
.active-button--active { color: #fff; text-decoration: undeline; /* border-bottom: 1px solid #8ce95d; color: #231e4a;  background: #8ce95d; */ }
</style>



// WEBPACK FOOTER //
// src/components/TimeFilter.vue